import React from 'react';
import { ArrowUpRight, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { services } from '../mock';

const CareAreas = () => {
  return (
    <section id="care" className="py-24 lg:py-32">
      <div className="max-w-[1240px] mx-auto px-6 grid lg:grid-cols-[380px_1fr] gap-16">
        {/* Left */}
        <div>
          <h2 className="text-[44px] lg:text-[56px] leading-[0.95] font-bold tracking-tight text-neutral-900">
            Our <br />
            <span className="font-serif-italic font-normal">Services</span>
          </h2>
          <p className="mt-5 text-neutral-600 text-[15px] leading-relaxed max-w-xs">
            Hands-on care, guided movement, and clear plans across every stage of recovery.
          </p>
          <Link
            to="/services"
            className="mt-6 inline-flex items-center gap-1 text-[14px] font-medium text-[#CA0028] group"
          >
            See All Services
            <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>

        {/* Right list */}
        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-x-14">
          {services.slice(0, 14).map((area) => {
            const Ic = area.icon;
            return (
              <Link
                key={area.slug}
                to={`/services/${area.slug}`}
                className="care-row group relative flex items-center justify-between border-b border-neutral-200 py-5 hover:border-[#CA0028] transition-colors"
              >
                <span className="flex items-center gap-3 text-[16px] font-medium text-neutral-900">
                  <Ic size={18} className="text-neutral-500 group-hover:text-[#CA0028] transition-colors" />
                  {area.name}
                </span>
                <span className="relative w-5 h-5">
                  <ArrowUpRight size={18} className="arrow-default text-neutral-400 group-hover:text-neutral-900" />
                  <ArrowUpRight size={18} className="arrow-hover text-neutral-900" />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CareAreas;
